import React from "react";
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY, AREAS, NAV_LINKS } from "../../data";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F172A] text-slate-300"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-5">
            <Logo light />
            <p className="text-sm leading-relaxed text-slate-400 max-w-xs">
              Reliable door-to-door valet trash services helping apartment
              communities across the Savannah area stay cleaner.
            </p>
            <div className="flex gap-3">
              {[
                { Icon: Facebook, label: "facebook" },
                { Icon: Instagram, label: "instagram" },
                { Icon: Linkedin, label: "linkedin" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#contact"
                  data-testid={`social-${label}`}
                  aria-label={label}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-white/5 hover:bg-[#2563EB] transition-colors"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white mb-5">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white mb-5">
              Service Areas
            </h4>
            <ul className="space-y-3 text-sm">
              {AREAS.map((a) => (
                <li key={a.name} className="text-slate-400">
                  {a.name}, GA
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white mb-5">
              Contact
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 mt-0.5 text-[#3B82F6]" />
                <span className="flex flex-col">
                  <a href={`tel:${COMPANY.phonePrimaryRaw}`} className="text-slate-300 hover:text-white">
                    {COMPANY.phonePrimary}
                  </a>
                  <a href={`tel:${COMPANY.phoneSecondaryRaw}`} className="text-slate-400 hover:text-white">
                    {COMPANY.phoneSecondary}
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-0.5 text-[#3B82F6]" />
                <a href={`mailto:${COMPANY.email}`} className="text-slate-300 hover:text-white break-all">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-[#3B82F6]" />
                <span className="text-slate-400">Savannah, Georgia</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-xs text-slate-500">
            Locally owned & operated · Fully insured
          </p>
        </div>
      </div>
    </footer>
  );
};
